<!-- eslint-disable -->
<template lang="pug">
    div(v-if="canShowConversations")
        | {{ $i18n.t('common.common_textInfo_pageNotAllowed') }}
    list-box(v-else)
        div(slot="header" )
            | {{ $i18n.t('conversations.conversations_conversationsHeader_messages') }}
        cs-button(
            color="blue"
            slot="button"
            @click="displayCreateMessageModal = true"
            v-if="user.type !== 'olympiads-student'"
        )
            | {{ $i18n.t('conversations.conversations_conversations_createMessage') }}
        .messages-box(slot="preview")
            .messages__menu.messages__menu--large
                a.menu__item(
                    href="javascript://"
                    @click="changeFilter()"
                    :class="{'menu__item--current': current === 'all'}"
                )
                    | {{ $i18n.t('conversations.conversations_conversationsMenu_all') }}
                a.menu__item(
                    href="javascript://"
                    @click="changeFilter({unread: true})"
                    :class="{'menu__item--current': current === 'unread'}"
                )
                    | {{ $i18n.t('conversations.conversations_conversationsMenu_unread') }} ({{ amountOfUnread }})
                router-link.menu__item(
                    :to="{name: 'messages', params: { favorite: true }}"
                )
                    | {{ $i18n.t('conversations.conversations_conversationsMenu_marked') }}
                    | ({{ amountOfFavorites }})
                a.menu__item(
                    href="javascript://"
                    @click="changeFilter({status: true})"
                    :class="{'menu__item--current': current === 'archive'}"
                )
                    | {{ $i18n.t('conversations.conversations_conversationsMenu_archive') }}
            .messages__body
                .messages__fields
                    .messages__menu
                        a.menu__item(
                            href="javascript://"
                            @click="changeFilter()"
                            :class="{'menu__item--current': current === 'all'}"
                        )
                            | {{ $i18n.t('conversations.conversations_conversationsMenu_all') }}
                        a.menu__item(
                            href="javascript://"
                            @click="changeFilter({unread: true})"
                            :class="{'menu__item--current': current === 'unread'}"
                        )
                            | {{ $i18n.t('conversations.conversations_conversationsMenu_unread') }} ({{ amountOfUnread }})
                        router-link.menu__item(
                            :to="{name: 'messages', params: { favorite: true }}"
                        )
                            | {{ $i18n.t('conversations.conversations_conversationsMenu_marked') }}
                            | ({{ amountOfFavorites }})
                        a.menu__item(
                            href="javascript://"
                            @click="changeFilter({status: true})"
                            :class="{'menu__item--current': current === 'archive'}"
                        )
                            | {{ $i18n.t('conversations.conversations_conversationsMenu_archive') }}
                    .fields__item
                        .messages-box__status-selector
                            cs-multiselect(
                                :multiple="false"
                                :options="['all', 'unread', 'marked', 'archive']"
                                @input="handleStatusSelect"
                                :value="current"
                                :custom-label="statusName"
                                :placeholder="statusName(current)"
                                :hide-selected="true"
                            )
                        .messages-box__search-box
                            .messages-box__search-item
                                cs-input(
                                    type="text"
                                    :placeholder="$i18n.t('conversations.conversations_conversations_searchPlaceholder')"
                                    v-model="message"
                                    @keyup.native.enter="search"
                                )
                                a(href='javascript://', @click="search")
                                    svg-icon.messages-box__search-icon(name="search" size="large")
                divider(:margin="'10px auto'")
                template(v-if="!isLoading" )
                    template(v-if="conversations.length > 0")
                        .messages-box__fields
                            cs-checkbox.messages-box__message-status-checkbox(v-model="allChecked")
                            .messages-box__message-statuses
                                a.messages-box__message-status(href="javascript://" @click="readChecked(true)")
                                    svg-icon.messages-box__status-icon(name="envelope-open" size="large")
                                    span {{ $i18n.t('conversations.conversations_conversations_makeRead') }}
                                a.messages-box__message-status(href="javascript://" @click="readChecked(false)")
                                    svg-icon.messages-box__status-icon(name="envelope" size="large")
                                    span {{ $i18n.t('conversations.conversations_conversations_makeUnread') }}
                                a.messages-box__message-status(href="javascript://" @click="archiveChecked")
                                    svg-icon.messages-box__status-icon(name="folder" size="large")
                                    span {{ statusState }}
                                a.messages-box__message-status(href="javascript://" @click="deleteChecked")
                                    svg-icon.messages-box__status-icon(name="trash" size="large")
                                    span {{ $i18n.t('conversations.conversations_conversations_delete') }}
                        divider(:margin="'0'")
                        .messages
                            div(v-for="conversation in conversations", :key="conversation.id")
                                .message
                                    cs-checkbox(
                                        :checked="!!checkedConversations.find(id => conversation.id === id)"
                                        @change="checkConversation(conversation.id, $event)"
                                    )
                                    message(:conversation="conversation")
                                divider(:margin="'0'")
                        pagination(
                            :last-page="lastPage"
                            :current-page="currentPage"
                            :total="total"
                            :length="conversations.length"
                            :from="from"
                            :to="to"
                        )
                    .messages__info(v-else)
                        | {{ emptyMessage }}
                cs-loader(v-else)
            create-message-modal(
                v-if="displayCreateMessageModal"
                @close="displayCreateMessageModal = false"
                @send="sendMessage"
            )

</template>

<script>
    /*eslint-disable*/
    import ConversationApi from '../../../api/communication/conversation';

    import amountsOfMessages from '../../../utils/communication/amountsOfMessages';
    import SendMessageMixin from '../../../utils/communication/sendMessageMixin';
    import canShowConversation from '../../../utils/user/canShowConversations';
    import receiveMessage from '../../../utils/communication/receiveMessage';

    import ListBox from '../../lists/ListBox.vue'
    import Pagination from '../../lists/Pagination.vue'
    import Message from '../Message.vue'
    const CreateMessageModal = () => import('../../../modals/CreateMessageModal.vue');

    import _ from 'lodash';
    import {mapState} from 'vuex';

    export default {
        data() {
            return {
                conversations: [],
                lastPage: null,
                total: null,
                currentPage: null,
                isLoading: false,
                from: null,
                to: null,
                form: {status: 'active'},
                displayCreateMessageModal: false,
                checkedConversations: [],
                allChecked: false,
                statusState: this.$i18n.t('conversations.conversations_conversations_archiveStatusActive'),
                message: '',
                isActive: false,
                current: '',
                page: null,
                isAmountsLoading: false
            };
        },
        mixins: [
            amountsOfMessages,
            SendMessageMixin,
            receiveMessage,
            canShowConversation
        ],
        props: ['queryPage', 'status', 'unread'],
        components: {
            Pagination,
            Message,
            ListBox,
            CreateMessageModal,
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            emptyMessage () {
                switch (this.current) {
                    case 'all':
                    case 'messages':
                        return this.$i18n.t('conversations.conversations_conversations_noMessages');
                    case 'unread':
                        return this.$i18n.t('conversations.conversations_conversations_noUnreadMessages');
                    case 'archive':
                        return this.$i18n.t('conversations.conversations_conversations_noArchivedMessages');
                }
            }
        },
        watch: {
            '$route': {
                handler(val) {
                    this.page = val.query.page;
                    this.fetchData();
                },
                deep: true
            },
            allChecked(val) {
                if (val) {
                    this.checkedConversations = this.conversations.map(conversation => conversation.id);
                } else {
                    this.checkedConversations = [];
                }
            }
        },
        methods: {
            readChecked(request) {
                this.isLoading = true;
                let conversationsIds = this.conversations
                .filter(conversation => conversation.lastMessage.unread === request && this.checkedConversations.includes(conversation.id))
                .map(conversation => conversation.id);
                let form = {
                    conversationsIds,
                    readAt: request
                };
                ConversationApi.updateSome(form)
                .then(data => {
                    this.fetchData();
                    this.checkedConversations = [];
                    this.allChecked = false;
                })
                .then(() => {
                    if (request) {
                        this.amountOfUnread -= conversationsIds.length;
                    } else {
                        this.amountOfUnread += conversationsIds.length;
                    }
                })
                .catch(error => {
                    this.$toasted.error(this.$root.$t('errors.message_handling'));
                    this.isLoading = false;
                });
            },
            deleteChecked() {
                if (this.checkedConversations.length > 0) {
                    ConversationApi.delete({conversationsIds: this.checkedConversations}, this.checkedConversations[0])
                    .then(() => {
                        this.fetchData();
                        this.checkedConversations.forEach(id => {
                            _.find(this.conversations, { id }).lastMessage.unread && (this.amountOfUnread--);
                        });
                        this.checkedConversations = [];
                        this.allChecked = false;
                    })
                    .catch(error => {
                        this.$toasted.error(this.$root.$t('errors.message_handling'));
                        this.isLoading = false;
                    });
                }
            },
            archiveChecked() {
                if (!this.checkedConversations || !this.checkedConversations.length) {
                    return;
                }
                this.isLoading = true;
                let form = {
                    conversationsIds: this.checkedConversations,
                    status: ''
                };
                if (this.statusState === this.$i18n.t('conversations.conversations_conversations_archiveStatusActive')) {
                    form.status = 'archived';
                } else if (this.statusState === this.$i18n.t('conversations.conversations_conversations_archiveStatusArchived')) {
                    form.status = 'active';
                    this.form.status = 'archived';
                }
                ConversationApi.updateSome(form)
                .then(data => {
                    if (this.checkedConversations.length !== 0) {
                        this.fetchData();
                    }
                    this.checkedConversations.forEach(id => {
                        _.find(this.conversations, { id }).lastMessage.unread && (this.amountOfUnread--);
                    });
                    this.checkedConversations = [];
                    this.allChecked = false;
                })
                .catch(error => {
                    this.$toasted.error(this.$root.$t('errors.message_handling'));
                    this.isLoading = false;
                });
            },
            search() {
                if (this.message.length > 0) {
                    this.$router.push({name: 'messages', params: {body: this.message}});
                }
            },
            changeFilter(request = {}) {
                this.page = null;
                this.$route.query.page = 1;
                this.current = 'all';
                this.isLoading = true;
                if (request.status) {
                    request = {status: 'archived'};
                    this.statusState = this.$i18n.t('conversations.conversations_conversations_archiveStatusArchived');
                    this.current = 'archive';
                } else {
                    Object.assign(request, {}, {status: 'active'});
                    this.statusState = this.$i18n.t('conversations.conversations_conversations_archiveStatusActive');
                }
                if (request.unread) {
                    this.current = 'unread';
                }
                Object.assign(this.form, request);
                this.isActive = false;
                this.fetchData();
            },
            fetchData() {
                this.isLoading = true;
                let form = {
                    page: this.page,
                    status: 'active'
                };
                this.form.status = this.current === 'archive' ? 'archived' : 'active';
                this.form.unread = this.current === 'unread' ? true : null;
                Object.assign(form, this.form);
                ConversationApi.list(form)
                .then((data) => {
                    this.conversations = data.data;
                    this.lastPage = data.lastPage;
                    this.total = data.total;
                    this.currentPage = data.currentPage;
                    this.from = data.from;
                    this.to = data.to;
                    if (this.lastPage > 0 && this.currentPage > this.lastPage) {
                        this.currentPage = this.lastPage;
                        this.$route.query.page = this.lastPage;
                        this.page = this.lastPage;
                        this.fetchData();
                    }
                    this.message = '';
                    this.form = {status: 'active'};
                    this.isLoading = false;
                })
                .catch((error) => {
                    this.isLoading = false;
                    this.$toasted.error(this.$root.$t('errors.message_handling'));
                });
            },
            checkConversation (conversationId, input) {
                input
                        ? this.checkedConversations.push(conversationId)
                        : (this.checkedConversations = this.checkedConversations.filter(id => id !== conversationId))
            },
            handleStatusSelect (selector) {
                switch (selector) {
                    case 'all':
                        this.changeFilter();
                        break
                    case 'unread':
                        this.changeFilter({unread: true});
                        break
                    case 'marked':
                        this.$router.push({name: 'messages', params: { favorite: true }});
                        break
                    case 'archive':
                        this.changeFilter({status: true});
                        break
                }
            },
            statusName (status) {
                status = status.replace('conversations.conversations_conversationsMenu_', '');
                return this.$i18n.t(`conversations.conversations_conversationsMenu_${status}`);
            }
        },
        mounted() {
            if (this.unread) {
                this.changeFilter({unread: this.unread});
                this.current = 'unread';
            } else if (this.status) {
                this.changeFilter({status: this.status});
                this.current = 'archive';
            } else {
                this.changeFilter();
                this.current = 'all';
            }
            this.$echo.private(`reload-conversations.${this.user.id}`).listen('ReloadConversations', this.fetchData);
        },
    }
</script>

<style lang="scss" scoped>
    .messages-box {
        display: flex;
    }

    .messages__menu {
        display: none;
        @include media($xlg) {
            display: flex;
            flex-direction: column;

            font-size: 18px;
            line-height: 42px;

            min-width: 180px;
            margin-right: 30px;
        }
        @include media($xl) {
            display: none;
        }
    }

    .messages__menu--large {
        display: none;
        @include media($xl) {
            display: flex;
        }
    }

    .menu__item {
        color: $hsl-color-blue-56;
        text-decoration: underline;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .menu__item--current {
        color: $x-color-black;
        text-decoration: none;
        &:hover {
            color: $x-color-black;
            text-decoration: none;
        }
    }

    .messages__body {
        padding: 0;
        width: 100%;
    }


    .messages__fields {
        display: flex;
        flex: 1 1 auto;
    }

    .fields__item {
        width: 100%;
    }

    .messages-box__status-selector {
        display: flex;
        @include media($xlg) {
            display: none;
        }
    }

    .messages-box__search-box {
        display: flex;
        margin: 15px 0;
        flex-direction: column;
        @include media($xlg) {
            margin: 0 0 15px;
            max-width: 300px;
        }
        @include media($xl) {
            flex-direction: row;
            margin: 15px 0;
        }
    }

    .messages-box__search-box .cs-input {
        margin: 0;
    }

    .messages-box__search-item {
        display: flex;
        align-items: center;
        width: 100%;
    }

    .messages-box__search-item:not(:last-child) {
        margin-bottom: 15px;
        @include media($md) {
            margin: 0 0 15px 0;
        }
        @include media($xl) {
            margin: 0 20px 0 0;
        }
    }

    .messages-box__search-icon {
        color: $hsl-color-blue-56;
        margin-left: 10px;
        margin-bottom: 6px;
    }

    .messages-box__fields {
        display: flex;
        padding: 0;
        margin: 30px 0;
    }

    .messages-box__message-statuses {
        display: flex;
        flex-direction: column;
        @include media($xlg) {
            flex-direction: row;
        }
    }

    .messages-box__message-status-checkbox {
        margin: 0 20px 0 0;
    }

    .messages-box__message-status {
        margin-bottom: 25px;
        display: flex;
        align-items: center;
        color: $hsl-color-blue-56;
        text-decoration: underline;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
        &:last-child {
            margin: 0;
        }
        @include media($xlg) {
            margin: 0 60px 0 0;
        }
    }

    .messages-box__status-icon {
        margin-right: 10px;
    }

    .message {
        display: flex;
        align-items: center;
        margin-bottom: 0;
        background-color: transparent;
        border-radius: 0;
        font-size: medium;
        &:hover {
            background-color: $hsl-color-gray-96;
        }
    }

    .messages__info {
        margin-top: 30px;
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        text-align: center;
    }
</style>
